<template>
  <div class="list" name="info">
    <el-col>
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" class="demo-inline-form" :model="search_form">
          <el-form-item label="商户编号">
            <el-input
              style="width:160px;"
              v-model="search_form.merchantId"
            ></el-input>
          </el-form-item>
          <el-form-item label="银联商户号">
            <el-input
              style="width:160px;"
              v-model="search_form.unionMchId"
            ></el-input>
          </el-form-item>
          <el-form-item label="商户简称">
            <el-input
              style="width:160px;"
              v-model="search_form.merchantName"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动类型">
            <el-select v-model="search_form.activityType" clearable>
              <el-option label="基础拓展" :value="2"></el-option>
              <!-- <el-option label="轻型终端" :value="3"></el-option> -->
              <!-- <el-option label="播报设备" :value="4"></el-option> -->
              <!-- <el-option label="银联二维码和手机闪付接费分润" :value="5"></el-option> -->
              <el-option label="疫情小微" :value="6"></el-option>
              <el-option label="2020聚合码牌" :value="7"></el-option>
              <el-option label="2020轻型终端" :value="8"></el-option>
              <el-option label="2020播报设备" :value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名状态">
            <el-select style="width:160px;" v-model="search_form.enrollmentStatus" clearable>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="审核驳回" :value="1"></el-option>
              <el-option label="报名成功" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <date-range-picker :value="[search_form.startTime, search_form.endTime]" @getChange="dateChange" disabledBeforeDate='-1'></date-range-picker>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              icon="el-icon-search"
              :plain="true"
              @click.native="buttonSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="export"
              :plain="true"
              download="银联活动信息导出.csv"
              icon="el-icon-download"
              @click.native="buttonExport"
              label="导出"
              :loading="exportLoading"></auth-button>
          </el-form-item>
          <el-form-item>
            <batch-import submitName="unionActivityBatchUpdate" failedIdText="商户编号" failedIdName="merchantId" @submit="importSubmit" templateUrl="unionpay-activity/downloadEnrollUnionpayTemplate"></batch-import>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="tableLoading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fMerchantId"
          label="商户编号（乐刷）"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerNo"
          label="银联商户号"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fMerNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fAgentId1g"
          label="一级代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="直属代理商编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fActivityType"
          label="活动类型"
          width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="activityName"
          label="活动名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="statusStr"
          label="报名状态"
          width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fRemark"
          label="备注"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fMsg || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fCreateTime"
          label="创建时间"
          width="165"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fStatus"
          label="操作"
          align="center"
          fixed="right"
          width="200"
          :context="_self">
          <template slot-scope="scope">
            <!--                    被驳回可以重新报名-->
            <auth-button opt="sign_up" type="text" v-if="scope.row.statusStr === '驳回'" @click.native="reSignUp(scope.row)" label="重新报名"></auth-button>
            <!--                    活动编辑仅仅商户列表修改-->
            <!-- <auth-button opt="edit" type="text" v-if="scope.row.statusStr === '驳回' " @click.native="editInfo(scope.row)" label="编辑活动资料"></auth-button> -->
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <el-dialog
      v-if="editDialogVisible"
      title="编辑活动资料"
      :visible.sync="editDialogVisible"
      size="small"
      @close="closeInfoDialog"
      width="400px"
      v-loading="dialogLoading">
      <el-form :model="infoForm" :rules="formRules" ref="infoForm" class="infoForm">
        <el-form-item label="商户编号">
          <span class="contentFont">{{ infoForm.merchantId }}</span>
        </el-form-item>
        <el-form-item label="银联商户号">
          <span class="contentFont">{{ infoForm.fMerNo }}</span>
        </el-form-item>
        <el-form-item label="商户简称">
          <span class="contentFont">{{ infoForm.merchantName }}</span>
        </el-form-item>
        <el-form-item label="活动类型">
          <span class="contentFont">{{ infoForm.fActivityType }}</span>
        </el-form-item>
        <el-form-item label="活动名称">
          <span class="contentFont">{{ infoForm.activityName }}</span>
        </el-form-item>
        <el-divider>活动资料补充</el-divider>
        <div v-if="[2, 5, 7].includes(infoForm.fActivityType)">
          <el-form-item label="" prop="unionpayDoorPhoto">
            <uploadImg
              v-model="infoForm.unionpayDoorPhoto"
              :value="infoForm.unionpayDoorPhoto"
              label="门头照"
              valueName="unionpayDoorPhoto"
              :required="true"
              @success="uploadSuccess"></uploadImg>
          </el-form-item>
          <el-form-item label="" prop="unionpayCashier">
            <uploadImg
              v-model="infoForm.unionpayCashier"
              :value="infoForm.unionpayCashier"
              label="收银台照"
              valueName="unionpayCashier"
              :required="true"
              @success="uploadSuccess"></uploadImg>
          </el-form-item>
          <el-form-item label="">
            <uploadImg
              v-model="infoForm.businessInside"
              :readonly="true"
              :value="infoForm.businessInside"
              label="经营场所照"
              valueName="businessInside"
              @success="uploadSuccess"></uploadImg>
          </el-form-item>
        </div>
        <div v-if="[3, 8].includes(infoForm.fActivityType)">
          <el-form-item label="" prop="unionpayLightEquipment">
            <uploadImg
              v-model="infoForm.unionpayLightEquipment"
              :value="infoForm.unionpayLightEquipment"
              label="设备图片"
              valueName="unionpayLightEquipment"
              :required="true"
              @success="uploadSuccess"></uploadImg>
          </el-form-item>
        </div>
        <div v-if="[4, 9].includes(infoForm.fActivityType)">
          <el-form-item label="" prop="unionpayVoiceEquipment">
            <uploadImg
              v-model="infoForm.unionpayVoiceEquipment"
              :value="infoForm.unionpayVoiceEquipment"
              label="设备图片"
              valueName="unionpayVoiceEquipment"
              :required="true"
              @success="uploadSuccess"></uploadImg>
          </el-form-item>
        </div>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="submit" :loading="submitLoading">保存资料</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import batchImport from '@/components/upload/batchImport'
import uploadImg from '@/components/upload/uploadImg'
import { unionActivityList, unionActivityUpdateInfo, unionActivitySignUp, exportUnionActivity } from '@/api/activity'
import { subAgentInfo } from '@/api/merchant'
import { singleTransPic } from '@/api/global'
import dateRangePicker from '@/components/dateRangePicker'
import { parseTime } from '@/utils/formatTime'
export default {
  name: 'UnionActivity',
  components: {
    batchImport,
    uploadImg,
    dateRangePicker
  },
  data () {
    // const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
    const todayZeroStr = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    return {
      search_form: {
        merchantId: '',
        unionMchId: '',
        // FBelongsAgentId: '',
        merchantName: '',
        activityType: '',
        enrollmentStatus: '',
        pageNo: 1,
        Count: 0,
        startTime: todayZeroStr,
        endTime: todayStr
      },
      checkLoading: false, // 查询按钮
      tableLoading: false, // 表格加载
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      list: [], // 信息列表
      salesNum: 0, // 条数
      agentId: '',
      roleName: '',
      agents_search_list: [],
      agents_search_list_back: [],
      editDialogVisible: false,
      infoForm: {
        merchantId: '',
        merchantName: '',
        fMerNo: '',
        // fActivityId: '',//活动id
        activityName: '', // 活动类型
        fActivityType: ''// 活动类型id
      },
      formRules: {
        unionpayDoorPhoto: [{
          trigger: 'change',
          validator: (rule, value, callback) => {
            if ((this.infoForm.fActivityType === 2 || this.infoForm.fActivityType === 5) && value === '') {
              callback(new Error('请上传门头照'))
            } else {
              callback()
            }
          }
        }],
        unionpayCashier: [{
          trigger: 'change',
          validator: (rule, value, callback) => {
            if ((this.infoForm.fActivityType === 2 || this.infoForm.fActivityType === 5) && value === '') {
              callback(new Error('请上传收银台照'))
            } else {
              callback()
            }
          }
        }],
        unionpayLightEquipment: [{
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.infoForm.fActivityType === 3 && value === '') {
              callback(new Error('请上设备照片'))
            } else {
              callback()
            }
          }
        }],
        unionpayVoiceEquipment: [{
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (this.infoForm.fActivityType === 4 && value === '') {
              callback(new Error('请上设备照片'))
            } else {
              callback()
            }
          }
        }]
      },
      dialogLoading: false,
      submitLoading: false,
      exportLoading: false
    }
  },
  mounted () {
    this.getUserInfo()
    this.getList()
    if (this.roleName !== 'operator') {
      this.getAgentsList()
    }
  },
  methods: {
    /**
             * @description 搜索点击
             */
    buttonSearch () {
      this.search_form.pageNo = 1
      this.search_form.Count = 0
      this.getList()
    },
    /**
             * @description 改变当前页事件
             * @param  {number} page 当前页码
             */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      this.search_form.pageNo = page
      this.search_form.Count = totalCount
      this.getList()
    },
    /**
             * @description 获取列表
             */
    getList () {
      this.search_form.merchantId = this.search_form.merchantId && this.search_form.merchantId.replace(/ /g, '')
      this.search_form.merchantName = this.search_form.merchantName && this.search_form.merchantName.replace(/ /g, '')
      if (!(this.search_form.merchantId || this.search_form.merchantName || this.search_form.unionMchId)) {
        if (!this.search_form.startTime || !this.search_form.endTime || this.search_form.endTime.substring(0, 8) !== this.search_form.startTime.substring(0, 8)) {
          this.$message({
            message: '商户编号、商户简称、银联商户号为空时请筛选1个月内的数据',
            type: 'error'
          })
          return
        }
      }
      this.tableLoading = true
      var data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      unionActivityList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.tableLoading = false
        } else {
          this.tableLoading = false
          this.paginations.total = data.totalCount
          this.list = data.list
          this.salesNum = data.totalCount
        }
      }).catch(() => {
      })
    },
    /**
             * @description 清除对象中无值属性
             * @param  {object} search 需要格式化的对象
             */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
             * @description 直属代理商自定义筛选方法
             */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.agents_search_list = this.agents_search_list_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.agents_search_list = this.agents_search_list_back
      }
    },
    /**
             * @description 获取用户信息
             */
    getUserInfo () {
      this.agentId = this.$store.getters.userId
      this.roleName = this.$store.getters.roleName
    },
    /**
             * @description 获取代理商列表方法
             */
    getAgentsList () {
      // 设一个超大的pageSize取所有数据
      subAgentInfo('pageSize=655350').then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
          const agentList = [{
            fAgentId: userInfo.fAgentId,
            fTitle: userInfo.fTitle
          }]
          this.agents_search_list = agentList.concat(data.list)
          this.agents_search_list_back = [...this.agents_search_list]
        }
      }).catch(() => {
      })
    },
    /**
             * @description 重新报名
             * @prams {object} row 列表行对象
             */
    reSignUp (row) {
      const data = qs.stringify({
        id: row.fId
      })
      unionActivitySignUp(data).then((data) => {
        if (data.error_code === '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'success'
          })
          this.getList()
        } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
             * @description 编辑活动资料
             * @prams {object} row 列表行对象
             */
    async editInfo (row) {
      // const that = this
      this.infoForm = this.$options.data().infoForm
      this.infoForm.merchantId = row.fMerchantId
      this.infoForm.merchantName = row.fMerchantName
      this.infoForm.fMerNo = row.fMerNo
      this.infoForm.activityName = row.activityName
      this.infoForm.fActivityType = row.fActivityType
      // 如果是基础拓展或者银联二维码和手机闪付接费分润，查询是否有已上传图片
      switch (this.infoForm.fActivityType) {
        case 2:
        case 5: {
          this.$set(this.infoForm, 'businessInside', row.businessInside || '')
          this.$set(this.infoForm, 'unionpayDoorPhoto', row.unionpayDoorPhoto || '')
          this.$set(this.infoForm, 'unionpayCashier', row.unionpayCashier || '')
          break
        }
        case 3: {
          this.$set(this.infoForm, 'unionpayLightEquipment', row.unionpayLightEquipment || '')
          break
        }
        case 4: {
          this.$set(this.infoForm, 'unionpayVoiceEquipment', row.unionpayVoiceEquipment || '')
          break
        }
        default: {
        }
      }
      this.editDialogVisible = true
    },
    /**
             * @description 批量导入回调
             * @prams {boolean} result 是否成功
             */
    importSubmit (result) {
      if (result) {
        this.getList()
      }
    },
    /**
             * @description 关闭弹窗
             */
    closeInfoDialog () {
      this.editDialogVisible = false
    },
    /**
             * @description 图片上传成功的回调
             */
    uploadSuccess (data) {
      const name = data.valueName
      this.infoForm[name] = data.path
    },
    submit () {
      const that = this
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          //    提交表单
          this.submitLoading = true
          const data = qs.stringify(that.infoForm)
          unionActivityUpdateInfo(data).then((data) => {
            this.submitLoading = false
            if (data.error_code === '0') {
              this.$message({
                showClose: true,
                message: data.error_msg,
                type: 'success'
              })
              this.editDialogVisible = false
              this.getList()
            } else {
              this.$message({
                showClose: true,
                message: data.error_msg,
                type: 'error'
              })
            }
          })
        } else {
          that.$message({
            message: '请完善资料后重试',
            type: 'warning'
          })
        }
      })
    },
    getUrl (url) {
      return new Promise((resolve, reject) => {
        if (url) {
          const param = qs.stringify({ path: url })
          singleTransPic(param).then(response => {
            if (response.error_code === '0') {
              resolve(response.data.show_path)
            } else {
              resolve(false)
            }
          }).catch((e) => {
            reject(e)
          })
        } else {
          resolve(false)
        }
      })
    },
    /**
             * 导出按钮
             */
    buttonExport () {
      if (!(this.search_form.merchantId || this.search_form.merchantName || this.search_form.unionMchId)) {
        if (!this.search_form.startTime || !this.search_form.endTime || this.search_form.endTime.substring(0, 8) !== this.search_form.startTime.substring(0, 8)) {
          this.$message({
            message: '商户编号、商户简称、银联商户号为空时请筛选1个月内的数据导出',
            type: 'error'
          })
          return
        }
      }
      // 当点击查询时，显示第一页
      this.search_form.pageNo = 1
      this.exportLoading = true
      this.exportList()
    },
    exportList () {
      var data = this.formatSearch(this.search_form)
      data = qs.stringify(data)
      exportUnionActivity(data).then(response => {
        this.exportLoading = false
        const nowDate = new Date()
        const timeString = nowDate.getFullYear() + '' +
                        (((nowDate.getMonth() + 1) < 10) ? ('0' + (nowDate.getMonth() + 1)) : (nowDate.getMonth() + 1)) +
                        ((nowDate.getDate() < 10) ? ('0' + nowDate.getDate()) : (nowDate.getDate())) +
                        ((nowDate.getHours() < 10) ? ('0' + nowDate.getHours()) : (nowDate.getHours())) +
                        ((nowDate.getMinutes() < 10) ? ('0' + nowDate.getMinutes()) : (nowDate.getMinutes())) +
                        ((nowDate.getSeconds() < 10) ? ('0' + nowDate.getSeconds()) : (nowDate.getSeconds()))
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '银联活动信息_' + this.agentId + '_' + timeString + '.csv')
        document.body.appendChild(link)
        link.click()
      }).catch(() => {
      })
    },
    dateChange (value) {
      [this.search_form.startTime, this.search_form.endTime] = value
    }
  }
}
</script>

<style scoped>
    .list{
        padding-left: 16px;
    }
    .btm-action {
        margin-top: 20px;
        text-align: center;
    }
    .pagination {
        display: inline-block;
    }
    .contentFont{
        font-size: 14px;
    }
    .infoForm .el-form-item{
        margin-bottom: 10px;
    }
    .el-select-dropdown__item{
        max-width: 300px;
    }
</style>
